import React from "react";
import EmailBuilderStore from "./stores/EmailBuilderStore";
import ReactPortalsRoot from '../ReactPortalsRoot/ReactPortalsRoot';
import ModalWarning from '../ModalWarning/ModalWarning';

export default class CodeToolbar extends React.Component{
	constructor(props) {
		super(props);
		this.state = {
			mergeTagModal: false,
		}
	}

	componentDidMount() {
		var self = this;

	  $(document.body).off('click.mergetagcodetoolbar').on('click.mergetagcodetoolbar', '.insert-merge-tag', function () {
	    var $this = $(this);
	    var textVariables = $this.parents('tr').find('td:first-child').html();

	    // ui cleanup
	    $('.tooltip').hide();
	    if (self.state.mergeTagModal) {
	    	self.setState({mergeTagModal: false});
	    }

	    // update EmailBuilder
	    EmailBuilderStore._insertTextVariables(textVariables);

	    return false;
	  });
	}

	render() {
		return (
			<div className="code-toolbar">
				<ul className="redactor-toolbar redactor-toolbar-external">
				<li><a onClick={this.openMergeTagModal} className="re-button re-mergetag re-button-icon">
						<i className="ss-newtag"></i><span className="re-button-tooltip" style={{display: 'none', marginLeft: '-44px'}}>{I18n.t('merge_tags')}</span>
					</a></li>
				</ul>
				{this.state.mergeTagModal ? this.renderMergeTagModal() : null}
			</div>
		);
	}

	renderMergeTagModal() {
		return (
		<ReactPortalsRoot
			children={[
				<ModalWarning
					key="body"
					title={this.getTitle()}
					body={<div dangerouslySetInnerHTML={{__html: this.getTemplate()}}></div>}
					onOK={() => this.setState({mergeTagModal: false})}
					onCancel={() => this.setState({mergeTagModal: false})}
				/>
			]}
			wrapperClassNames="ModalWarningWrapper"
		/>
		)

	}

	openMergeTagModal() {
    this.setState({mergeTagModal: true});
	}

  getTemplate() {
    if (this.props.email.email_type == "campaign") {
      var help_type = "campaign"
    } else if (this.props.email.lifecycle_event == undefined || this.props.email.lifecycle_event == 'reservation_created' || this.props.email.lifecycle_event == 'reservation_start_date' || this.props.email.lifecycle_event == 'reservation_end_date') {
      var help_type = "reservation";
    } else {
      var help_type = "room";
    }
    var tmpl = '';// '<div style="max-width: 100%; max-height: 300px; overflow: scroll; margin: -20px 0;">';

    // reservation merge tags
    tmpl += '<div class="reservation-email" style="display:' + (help_type == 'reservation' ? 'block' : 'none') + '">';
    tmpl += I18n.t('reservation_email_merge_tag_instructions');
    tmpl += '</div>';

    // room merge tags
    tmpl += '<div class="room-email" style="display:' + (help_type == 'room' ? 'block' : 'none') + '">';
    tmpl += I18n.t('room_email_merge_tag_instructions');
    tmpl += '</div>';

    // folio merge tags
    tmpl += '<div class="folio-email" style="display:' + (help_type == 'folio' ? 'block' : 'none') + '">';
    tmpl += I18n.t('folio_email_merge_tag_instructions');
    tmpl += '</div>';

    // campaign merge tags
    tmpl += '<div class="campaign-email" style="display:' + (help_type == 'campaign' ? 'block' : 'none') + '">';
    tmpl += I18n.t('campaign_email_merge_tag_instructions');
    tmpl += '</div>';

    tmpl += '</div>';

    // return tmpl;
   
    return (
    // <div
    //   key="ModalDuplicateConfirmation"
    //   className="ModalWarning modal-content"
    // >
      <div className="description" dangerouslySetInnerHTML={{ __html: tmpl }}></div>
    // </div>
    )
  }

  getTitle() {
    
    return I18n.t(this.props.email.lifecycle_event || this.props.email.email_type) + ' - ' + I18n.t('merge_tags');
  }

};
